// extracted by mini-css-extract-plugin
export default {"cleopatra":"cleopatra_cleopatra__+f9hn","closeButton":"cleopatra_closeButton__j-sct"};